import React, { useEffect, useState } from 'react'
import { ApiGetCall } from '../../JS/Connector';

export default function BillingDetailModal({ schoolId }) {
    const [schoolData, setSchoolData] = useState(null);
    useEffect(() => {
        getSchoolProfileInfo();
    }, [])
    async function getSchoolProfileInfo() {
        await ApiGetCall(`/schools/profile-info?schoolId=${schoolId}`, null, true).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setSchoolData(responseRs)
            }
        });
    }
    return (
        <div className='row'>
            <div className='col-md-12 pb-2 d-flex align-items-center'>
                <div className='fw-600'>Add Account Credit:</div>
                <div className='ps-2'>{schoolData?.schoolProfile?.billing_account_credit || '-'}</div>
            </div>
            <div className='col-md-12 pb-2 d-flex align-items-center'>
                <div className='fw-600'>Account Credit Usage:</div>
                <div className='ps-2'>{schoolData?.schoolProfile?.mapped_billing_account_credit_usage || '-'}</div>
            </div>
            <div className='col-md-12 pb-2 d-flex align-items-center'>
                <div className='fw-600'>Account Credit Notes:</div>
                <div className='ps-2'></div>
            </div>
            <div className='col-md-12 pb-2 d-flex align-items-center'>
                <div className='fw-600'>Pricing:</div>
                <div className='ps-2'>{schoolData?.schoolProfile?.default_pricing == 1 ? 'Default' : schoolData?.schoolProfile?.default_pricing == 2 ? "Custom" : '-'}</div>
            </div>
            <div className='col-md-12 pb-2 d-flex align-items-center'>
                <div className='fw-600'>Special Discounts or Pricing:</div>
                <div className='ps-2'>{schoolData?.schoolProfile?.special_discount || '-'}</div>
            </div>
            <div className='col-md-12 pb-2 d-flex align-items-center'>
                <div className='fw-600'>Repair Price Tier:</div>
                <div className='ps-2'>{schoolData?.schoolProfile?.mapped_repair_price_tier || '-'}</div>
            </div>
        </div>
    )
}
